export function useIsNewCircle(slug: MaybeRefOrGetter<string>) {
  return computed(() => NEW_CIRCLES.includes(toValue(slug) as NewCircleSlug));
}
